import { useList } from '@refinedev/core'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import type { CrudFilter } from '@refinedev/core'

interface StatCardProps {
  label: string
  resource: string
  filters?: CrudFilter[]
  accent?: string
}

const ACCENTS = [
  'bg-sky-50 dark:bg-sky-900/30 text-[#076698] dark:text-sky-300',
  'bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-300',
  'bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-300',
  'bg-rose-50 dark:bg-rose-900/30 text-rose-500 dark:text-rose-300',
  'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300',
]

let accentIndex = 0

export function StatCard({ label, resource, filters, accent }: StatCardProps) {
  const { data, isLoading } = useList({
    resource,
    pagination: { pageSize: 1 },
    filters: filters ?? [],
  })

  const accentClass = accent ?? ACCENTS[accentIndex++ % ACCENTS.length]

  return (
    <div className={cn(
      'bento-card bento-card-hover p-6 flex flex-col justify-between min-h-[120px]',
    )}>
      <div className={cn('w-10 h-10 rounded-2xl flex items-center justify-center mb-3', accentClass)}>
        <span className="text-lg font-extrabold">#</span>
      </div>
      <div>
        <p className="section-label mb-1">{label}</p>
        {isLoading ? (
          <Skeleton className="h-8 w-20" />
        ) : (
          <p className="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight leading-none">
            {(data?.total ?? 0).toLocaleString()}
          </p>
        )}
      </div>
    </div>
  )
}
